import axios from "axios";
import Instense from "./Axios-config";
import { API_ROOT } from "./Api-config";
 
export class COAService {

public static GetCOA = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/ChartofAccounts/GetCOA`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetMainGrps = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
     
    request.tenantid = tenantID;
    const url = `/ChartofAccounts/GetMainGrps`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };


public static SaveMainGrps = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantid = tenantID;

  const queryParams = new URLSearchParams(request).toString();

  const url = `/ChartofAccounts/SaveMainGrps?${queryParams}`;

  return Instense.post(url).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};



  public static GetSubGrps = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
     
    request.tenantid = tenantID;
    const url = `/ChartofAccounts/GetSubGrps`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };


  public static SaveSubGrps = async (request: any): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
    request.tenantid = tenantID;
  
    const queryParams = new URLSearchParams(request).toString();
  
    const url = `/ChartofAccounts/SaveSubGrps?${queryParams}`;
  
    return Instense.post(url).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static GetSubGrps2 = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
     
    request.tenantid = tenantID;
    const url = `/ChartofAccounts/GetSubGrps2`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static SaveSubGrps2 = async (request: any): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
    request.tenantid = tenantID;
  
    const queryParams = new URLSearchParams(request).toString();
  
    const url = `/ChartofAccounts/SaveSubGrps2?${queryParams}`;
  
    return Instense.post(url).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static SaveSubGrps3 = async (request: any): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
    request.tenantid = tenantID;
  
    const queryParams = new URLSearchParams(request).toString();
  
    const url = `/ChartofAccounts/SaveSubGrps3?${queryParams}`;
  
    return Instense.post(url).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static GetSubGrps3 = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
     
    request.tenantid = tenantID;
    const url = `/ChartofAccounts/GetSubGrps3`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static GetRowtitle = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
     
    request.tenantid = tenantID;
    const url = `/ChartofAccounts/GetRowtitle`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static SaveRowtitle = async (request: any): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
    request.tenantid = tenantID;
  
    const queryParams = new URLSearchParams(request).toString();
  
    const url = `/ChartofAccounts/SaveRowtitle?${queryParams}`;
  
    return Instense.post(url).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };


public static SaveCOA = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
  request.tenantid = tenantID;
  
  const url =`/ChartofAccounts/SaveCOA`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};



}